import { Image } from './image';
import { EArticleClass, EUserType, UserTypeUtil } from 'shared/models';

export interface Topic {
  topicId: string;
  topicName: string;
  description: string;
  viewCount: number;
  articles?: TopicArticle[];
}

export interface TopicArticle {
  groupId: string;

  authorId: string;

  authorLinkName: string;

  authorType: EUserType;

  articleClass: EArticleClass;

  title: string;

  shortContent: string;

  largeImage: Image;

  articleLikes: number;
}

export const LegacyTopicArticleUtil = {
  getArticlePath: (article: TopicArticle): string => {
    const prefix = UserTypeUtil.getLinkNamePrefix(article.authorType);

    return `/${prefix}${article.authorLinkName}/${article.groupId}`;
  },

  getAuthorPath: (article: TopicArticle): string => {
    const prefix = UserTypeUtil.getLinkNamePrefix(article.authorType);

    return `/${prefix}${article.authorLinkName}`;
  },
};
